import { render, staticRenderFns } from "./level3.vue?vue&type=template&id=59a938ec&scoped=true&"
import script from "./level3.vue?vue&type=script&lang=js&"
export * from "./level3.vue?vue&type=script&lang=js&"
import style0 from "./level3.vue?vue&type=style&index=0&id=59a938ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a938ec",
  null
  
)

export default component.exports